import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const fade = (delay) => ({
    initial: { opacity: 0, y: 24 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
});

const Hero = () => {
    const { user } = useAuth();
    return (
    <section data-testid="hero-section" className="relative overflow-hidden">
        <div className="absolute inset-0">
            <img
                src="/brand/hero-bg.webp"
                alt="SHREDxpro athlete training with headphones"
                data-testid="hero-image"
                className="h-full w-full object-cover object-[center_30%]"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#070c15] via-[#070c15]/85 to-[#070c15]/35" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#070c15] via-transparent to-[#070c15]/60" />
        </div>

        <div className="relative z-10 mx-auto flex min-h-[92vh] max-w-7xl items-center px-5 pb-20 pt-32 sm:px-8">
            <div className="max-w-2xl">
                <motion.p {...fade(0.05)} className="eyebrow" data-testid="hero-eyebrow">
                    Your Personalized Fitness System
                </motion.p>
                <motion.h1
                    {...fade(0.15)}
                    data-testid="hero-heading"
                    className="font-display mt-5 text-5xl leading-[1.05] text-white sm:text-6xl lg:text-7xl"
                >
                    Your body. Your goal.{" "}
                    <span className="bg-gradient-to-r from-[#45d1f5] to-[#f0356f] bg-clip-text text-transparent">
                        Your plan.
                    </span>
                </motion.h1>
                <motion.p
                    {...fade(0.25)}
                    data-testid="hero-subtitle"
                    className="mt-6 max-w-lg text-base leading-relaxed text-[#c0cbdc] sm:text-lg"
                >
                    Personalized workouts. Personalized nutrition. AI coaching. Smart tracking.
                    All in one place.
                </motion.p>
                <motion.div {...fade(0.35)} className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center">
                    <Link to={user ? "/trial" : "/register?trial=1"} data-testid="hero-primary-cta" className="btn-primary">
                        Start 7-Day Free Trial <ArrowRight className="h-4 w-4" />
                    </Link>
                </motion.div>
                <motion.div {...fade(0.45)} className="mt-8 flex flex-wrap gap-3" data-testid="hero-trial-note">
                    {["7 Days Free", "Full Access", "Cancel Anytime"].map((c) => (
                        <span key={c} className="chip">
                            <Check className="h-3.5 w-3.5 text-[#3fcbf3]" />
                            {c}
                        </span>
                    ))}
                </motion.div>
            </div>
        </div>
    </section>
    );
};

export default Hero;
